import React, { Component } from "react";
import { Link } from "react-router-dom";

import athena_menu from "../assets/reg_holds/athena_menu.JPG";

export default class registrationHolds extends Component {
  constructor(props) {
    super(props);
    this.state = { showAthenaMenu: false };
  }

  toggleImageDisplay = () => {
    this.setState({ showAthenaMenu: !this.state.showAthenaMenu });
  };

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div>
            A registration hold prevents a student from registering for classes for the upcoming semester. Registration holds can be placed
            on a student for various reasons by Student Financial Services, the Student Health Center, or other authorized individuals.
            <br />
            <hr />
            <p>
              Students with holds on their record will not be permitted to register until holds have been cleared. Holds can be viewed in
              the registration system within Athena.
            </p>
            <p>To view holds,</p>
            <ol>
              <li>
                Go to{" "}
                <a href="http://athena.uga.edu/" target="_blank" rel="noreferrer" className="redLink">
                  Athena
                </a>{" "}
              </li>
              <li>Login with UGA MyID and password</li>
              <li>Click Student</li>
              <li>
                Click Student & Registration (If you can't find this the option is in the menu bar at the top left&nbsp;&nbsp;
                <button className="btn btn-outline-primary" onClick={this.toggleImageDisplay}>
                  {this.state.showAthenaMenu ? "Hide" : "Show"}
                </button>{" "}
                )
              </li>
              {this.state.showAthenaMenu ? (
                <div className="text-center">
                  <img src={athena_menu} className="rounded img-thumbnail" alt="TA ship form" />
                </div>
              ) : null}

              <li>Click Student Profile</li>
              <li>In upper right corner of the Student Profile page, click Holds.</li>
            </ol>
            <hr />
            There are 4 main registration holds that I will cover here:
            <ol>
              <li>
                Transcript and Degree Certificate - Provide original transcripts to university -{" "}
                <Link to={"/postAdmission/transcripts"}>Transcript</Link>
              </li>
              <li>
                Immunization Hold - Provide Vaccination details - <Link to={"/postAdmission/immunization"}>Immunization</Link>{" "}
              </li>
              <li>
                Student Acknowledegment Hold: &nbsp;
                <a
                  href="https://busfin.uga.edu/bursar/athena_student_acknowledgement_screen_shot_instructions.pdf"
                  target={"_blank"}
                  rel={"noreferrer"}
                >
                  Steps to clear hold with images
                </a>
                <br />
                Link to ATHENA -{" "}
                <a href="https://athena.uga.edu/" target={"_blank"} rel={"noreferrer"}>
                  ATHENA
                </a>
              </li>
              <li>LawFul Verification - This hold will be removed after you enter the US, no need to worry about this now.</li>
            </ol>
            <p>If you are unable to register to classes due to hold 4 - contact the department</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
